// --------------------------------------------------------
// CARE LINE LIST ITEM - CareLineListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from 'react'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { Text, ListItemContainer, Table, TableData, TextLink } from '../UI/generalLayout/Layout.styled'
import { ReactComponent as CareLine } from '../../assets/imgs/careLine.svg'
import Colors from '../../constants/Colors';
import { StyledSwitch } from '../companyListItem/CompanyListItem.styled';
import { ItemInfoContainer, MobileContainer, SwitchContainer, ViewEditContainer } from '../companyListItem/CompanyListItemMobile.styled';
import ActivateInactivateModal from '../activateInactivateModal/ActivateInactivateModal';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARE LINE LIST ITEM INTERFACE
// --------------------------------------------------------

interface ICareLineListItem{
    id:string;
    companyId?: string;
    isOccupHealth?: boolean;
    name: string;
    isActiveRegister: boolean;// Colocar CareLine aqui quando modelar a entidade
    onEdit: any;
    onView: any;
    onActivateInactivate: any;
}
/**
/**
 * A component that renders a Care line list item.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CareLineListItem = ({name, id, isOccupHealth = false, companyId = '', isActiveRegister, onEdit, onView, onActivateInactivate}:ICareLineListItem) => {
  // --------------------------------------------------------
  // CARE LINE LIST ITEM PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo()
  const [isActive, setIsActive] = useState(isActiveRegister)
  const [showModalAtivarInativar, setShowModalAtivarInativar] = useState(false)

    useEffect(()=>{
        setIsActive(isActiveRegister)
    }, [isActiveRegister])

    const activateOrInactivateCareLine = async (event: any)=>{
        try{
            if(isOccupHealth){
                onActivateInactivate(companyId, id, !isActive)
            }else{
                onActivateInactivate(id, !isActive)
            }
            setIsActive(prev=>!prev)
            setShowModalAtivarInativar(false)
        }catch(error: any){
            
        }
    }

    const onChangeSwitchValue = (event: any) => {
        setShowModalAtivarInativar(true)
     }

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
        <ListItemContainer disabled={!isActive} style={{ marginTop: isMobile? 16 : 0}}>
            {!isMobile? 
            (<Table>
                <TableData width={'7%'} style={{ verticalAlign: 'middle'}}>
                    <CareLine style={{ opacity: isActive? 1 : 0.4 }} />
                </TableData>
                <TableData width={'60%'}>
                    <Text bold color={isActive? '':Colors.GRAY400}>{name}</Text>
                </TableData>
                <TableData width={'10%'} alignRight={true}>
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}
                            disabled={!isActive} 
                            onClick={!isActive? undefined : onEdit}>
                                EDITAR
                        </TextLink>
                    </TableData>
                    <TableData width={'12%'} alignRight={true}>
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}
                            onClick={onView}>
                                VISUALIZAR
                        </TextLink>
                    </TableData>
                    <TableData width={'20%'} alignRight={true}>
                        <StyledSwitch 
                            style={{ color: Colors.SPM600 }}
                            checked={isActive}
                            onChange={onChangeSwitchValue}
                        />
                    </TableData>
            </Table>)
            :
            (<MobileContainer>
                <ItemInfoContainer>
                    <Text bold>{name}</Text>
                <ViewEditContainer>
                    <TextLink 
                        disabled={!isActive} 
                        bold 
                        color={Colors.SPM500} 
                        style={{ fontSize: 12 }} 
                        onClick={!isActive? undefined : onEdit}>
                        EDITAR
                    </TextLink>
                    <TextLink 
                        bold 
                        color={Colors.SPM500} 
                        style={{ fontSize: 12 }} 
                        onClick={onView}>
                        VISUALIZAR
                    </TextLink>
                </ViewEditContainer>
                </ItemInfoContainer>

                <SwitchContainer>
                    <StyledSwitch
                        sx={{ width: 60 }}
                        style={{ color: Colors.SPM600, width: 45 }}
                        checked={isActive}
                        onChange={onChangeSwitchValue}
                    />                
                </SwitchContainer>
            </MobileContainer>)}
        </ListItemContainer>
        <ActivateInactivateModal 
            isActivate={!isActive}
            visible={showModalAtivarInativar}
            onCancel={() => { setShowModalAtivarInativar(false) } }
            onConfirmCancellation={activateOrInactivateCareLine} 
            ativarButtonMsg={`Ativar`} 
            inativarButtonMsg={`Inativar`} 
            modalMsg={`Tem certeza que deseja ${isActive? 'inativar':'ativar'} a linha de cuidado "${name}"?`}                     
        />
    </>
  )
  // --------------------------------------------------------
}

export default CareLineListItem